<div class="header" [class.mobile]="navigationService.useMobileNav$ | async">
    <button class="header-action" (click)="toggleOpen()"
            [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active':isOpen}">
        <div class="header-action-media" [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active':isOpen}">
            <fui-icon class="header-action-media-object" [height]="8" [icon]="'chevron-right'"
                      id="toggle-icon" [width]="6"></fui-icon>
        </div>
        <div class="header-action-label" [class.mobile]="navigationService.useMobileNav$ | async">
            <div class="header-action-label-title" id="toggle-title">
                {{group.title | translate}}
            </div>
        </div>
    </button>
</div>
<div class="links" [class.mobile]="navigationService.useMobileNav$ | async" *ngIf="isOpen" [@toggle]>
    <ng-container *ngFor="let link of group.links; let index = index">
        <fui-navigation-link id="link-{{index}}" [link]="link" *ngIf="!link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE"></fui-navigation-link>
        <fui-navigation-group id="group-{{index}}" [group]="link" *ngIf="link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE"></fui-navigation-group>
    </ng-container>
</div>



